<template>
  <div v-if="counter === 0">
    <v-progress-circular v-if="progressType === 'circular'" class="ma-5" :indeterminate="true" :size="size" :width="width" :color="color"></v-progress-circular>
    <v-progress-linear v-if="progressType === 'linear'" :indeterminate="true" :height="height" :color="color"></v-progress-linear>
  </div>
  <div v-else>
    <v-alert
      :value="true"
      color="error"
      icon="warning"
      outline
    >
      <p>{{ $t('general.noDataLoaded') }}</p>
      <v-btn color="error" @click.native="reload">{{ $t('general.reloadPageNow') }}</v-btn>
    </v-alert>
  </div>
</template>

<script>

export default {
  props: {
    progressType: {
      type: String,
      default: 'circular'
    },
    color: {
      type: String,
      default: 'green'
    },
    size: {
      type: Number,
      default: 100
    },
    width: {
      type: Number,
      default: 2
    },
    height: {
      type: Number,
      default: 3
    }
  },
  data () {
    return {
      timer: null,
      counter: 0
    }
  },
  methods: {
    reload () {
      location.reload()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/client/components/Loader.vue